import React, {useRef} from 'react';
import PropTypes from 'prop-types';

import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
  useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';

import {ConfigurationPanel} from '@amblique/king-living/app/components/configuration-selector/configuration-panel';

/**
 * Mobile bottom-sheet Drawer — thin layout shell only.
 * Owns the Drawer/DrawerContent structure and Visual Viewport positioning.
 * Delegates all header + content rendering to ConfigurationPanel.
 */
export const MobileDrawerView = ({
  complexGalleryState,
  configProducts,
  drawerViewportRect,
  effectiveSelectedId,
  headerTitle,
  isLoading,
  isOpen,
  panelHeaderInfo,
  panelMode,
  product,
  selectedProduct,
  onClose,
  onDone,
  onGalleryProductChange,
  onHeaderChange,
  onSelect,
  onSlotProductPreview,
  onViewDetails,
  setDrawerEscHandler,
}) => {
  const styles = useMultiStyleConfig('ConfigurationSelector', {});
  const mobileDrawerInitialFocusRef = useRef(null);

  return (
    <Drawer
      blockScrollOnMount={false}
      initialFocusRef={mobileDrawerInitialFocusRef}
      isOpen={isOpen}
      placement="bottom"
      returnFocusOnClose
      size="full"
      onClose={onClose}
    >
      <DrawerOverlay {...styles.overlay} />
      <DrawerContent
        {...styles.content}
        {...(drawerViewportRect ?
          {
            bottom: 'auto',
            height: drawerViewportRect.height,
            left: drawerViewportRect.left,
            maxHeight: drawerViewportRect.height,
            position: 'fixed',
            right: 'auto',
            top: drawerViewportRect.top,
            width: drawerViewportRect.width,
          } :
          {})
        }
      >
        <ConfigurationPanel
          complexGalleryState={complexGalleryState}
          configProducts={configProducts}
          drawerHeight={drawerViewportRect?.height}
          effectiveSelectedId={effectiveSelectedId}
          headerTitle={headerTitle}
          isLoading={isLoading}
          isMobile={true}
          mobileDrawerInitialFocusRef={mobileDrawerInitialFocusRef}
          panelHeaderInfo={panelHeaderInfo}
          panelMode={panelMode}
          product={product}
          selectedProduct={selectedProduct}
          onClose={onClose}
          onDone={onDone}
          onGalleryProductChange={onGalleryProductChange}
          onHeaderChange={onHeaderChange}
          onSelect={onSelect}
          onSlotProductPreview={onSlotProductPreview}
          onViewDetails={onViewDetails}
          setDrawerEscHandler={setDrawerEscHandler}
        />
      </DrawerContent>
    </Drawer>
  );
};

MobileDrawerView.displayName = 'MobileDrawerView';

MobileDrawerView.propTypes = {
  complexGalleryState: PropTypes.object,
  configProducts: PropTypes.array,
  drawerViewportRect: PropTypes.object,
  effectiveSelectedId: PropTypes.string,
  headerTitle: PropTypes.string,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  panelHeaderInfo: PropTypes.object,
  panelMode: PropTypes.string,
  product: PropTypes.object.isRequired,
  selectedProduct: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onGalleryProductChange: PropTypes.func,
  onHeaderChange: PropTypes.func,
  onSelect: PropTypes.func,
  onSlotProductPreview: PropTypes.func,
  onViewDetails: PropTypes.func,
  setDrawerEscHandler: PropTypes.func,
};
